import { useNavigation } from "@react-navigation/native";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import { useContext, useEffect } from "react";
import { SafeAreaManagerContext } from "../contexts/SafeAreaManager";
import { ColorValue } from "react-native";

type ScreenParams = StackScreenProps<RootStackParamList>;

export const useChangeStatusBarColor = (color: ColorValue) => {
    const navigator = useNavigation<ScreenParams["navigation"]>();
    const { setStatusBarColor, resetStatusBarColor } = useContext(SafeAreaManagerContext);

    useEffect(() => {
        const setStatusBarBackgroundToOnPrimary = () => {
            setStatusBarColor(color);
        };
        const setStatusBarBackgroundToWhite = () => {
            resetStatusBarColor();
        };

        navigator.addListener("focus", setStatusBarBackgroundToOnPrimary);
        navigator.addListener("blur", setStatusBarBackgroundToWhite);

        return () => {
            navigator.removeListener("focus", setStatusBarBackgroundToOnPrimary);
            navigator.removeListener("blur", setStatusBarBackgroundToWhite);
        };
    }, [color, navigator, resetStatusBarColor, setStatusBarColor]);
};
